import { FormGroup, Label, Input, UncontrolledDropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { centres } from "../constants";
import { useState } from "react";
import { filterActions } from "../reducers";

export const CustomDropdownItem = ({ index, colorTag = undefined, label, onChange, checked, defaultValue }) => (
	<div className="d-flex">
		{colorTag && (
			<span
				className="pl-3 ml-2 pr-2 my-2 rounded mr-2"
				style={{
					backgroundColor: colorTag,
				}}
			></span>
		)}
		<FormGroup
			check
			className="mt-0 py-1 px-2"
			style={{
				marginTop: 0,
				marginBottom: 0,
				...(index === centres.length - 1 && {
					borderBottomLeftRadius: 2,
					borderBottomRightRadius: 2,
				}),
				...(index === 0 && {
					borderTopLeftRadius: 2,
					borderTopRightRadius: 2,
				}),
			}}
		>
			<Label check>
				<Input type="checkbox" onChange={onChange} checked={checked} />
				<span className="form-check-sign">
					<span className="check"></span>
				</span>
				<span className="text-dark">{label}</span>
			</Label>
		</FormGroup>
	</div>
);

export const TeacherFilterDropdown = ({ dispatchFilterParams, teacherOptions, filterParams }) => {
	const [teacherLabelKeyword, setTeacherLabelKeyword] = useState("");

	return (
		<UncontrolledDropdown group className="ml-0">
			<DropdownToggle caret color="info" data-toggle="dropdown">
				Filter By Teacher
			</DropdownToggle>
			<DropdownMenu
				style={{
					paddingTop: 0,
					paddingBottom: 0,
					maxHeight: "70vh",
					overflowY: "auto",
				}}
			>
				<div className="d-flex text-dark">
					<input
						type="text"
						placeholder="Search"
						className="form-control my-1 text-dark form-control-sm mx-2 border-light"
						style={{ borderRadius: 5 }}
						onChange={(e) => setTeacherLabelKeyword(e.target.value)}
					/>
				</div>
				<CustomDropdownItem
					onChange={(event) =>
						dispatchFilterParams({
							type: filterActions.SELECT_ALL_TEACHERS,
							payload: event.target.checked,
						})
					}
					label="Select all"
					checkBoxShow={false}
				/>
				{teacherOptions
					?.filter(
						(teacher) =>
							(teacher.label === "Unassigned" || teacher?.value?.active) &&
							(!teacherLabelKeyword ||
								teacher.label === "Unassigned" ||
								teacher.label.toLowerCase().includes(teacherLabelKeyword.toLowerCase()))
					)
					.map((teacher, index) => (
						<CustomDropdownItem
							key={index}
							onChange={(event) =>
								dispatchFilterParams({
									type: filterActions.TEACHER,
									payload: {
										teacherId: teacher?.value.id,
										show: event.target.checked,
									},
								})
							}
							label={teacher.label}
							index={index}
							checked={filterParams.teacherFilter[teacher?.value.id]?.show}
						/>
					))}
			</DropdownMenu>
		</UncontrolledDropdown>
	);
};
